export const useEditor = (props, emit) => {
    const openEditor = ref(false);
    const currentEditor = ref(null);
  
    const openEditorSheet = (feature) => {
      openEditor.value = true;
      currentEditor.value = feature.editor;
    };
  
    const saveEditor = (e) => {
      // handle saving editor state
      openEditor.value = false;
    };
  
    return {
      openEditor,
      currentEditor,
      openEditorSheet,
      saveEditor
    };
  };
  